import { useState } from "react";
import { motion } from "framer-motion";
import { PORTRAITS } from "@/lib/data";

function Portrait({ name, src, fallback, caption }) {
 const [imgSrc, setImgSrc] = useState(src);
 return (
 <div className="relative group overflow-hidden border border-ink-600">
 <img
 src={imgSrc}
 alt={name}
 onError={() => setImgSrc(fallback)}
 className="w-full aspect-[4/5] object-cover transition-transform duration-700 group-hover:scale-105"
 />
 <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" />
 <div className="absolute bottom-0 left-0 right-0 p-5">
 <p className="tag-kicker">{caption}</p>
 <p className="font-display text-xl md:text-2xl font-bold mt-1">
 {name}
 </p>
 </div>
 </div>
 );
}

export default function Founders() {
 return (
 <section
 data-testid="founders-section"
 id="founders"
 className="relative bg-ink-900 py-24 md:py-36 border-t border-ink-600"
 >
 <div className="max-w-7xl mx-auto px-4 md:px-8 grid md:grid-cols-12 gap-12">
 <motion.div
 initial={{ opacity: 0, y: 20 }}
 whileInView={{ opacity: 1, y: 0 }}
 viewport={{ once: true }}
 transition={{ duration: 0.6 }}
 className="md:col-span-5 lg:col-span-4"
 >
 <div className="relative grid grid-cols-2 gap-4">
 <div className="pt-10">
 <Portrait
 name="Devon DeVries"
 src={PORTRAITS.devon.enhanced}
 fallback={PORTRAITS.devon.fallback}
 caption="Co-founder"
 />
 </div>
 <div>
 <Portrait
 name="Becki DeVries"
 src={PORTRAITS.becki.enhanced}
 fallback={PORTRAITS.becki.fallback}
 caption="Co-founder"
 />
 </div>
 </div>
 </motion.div>

 <motion.div
 initial={{ opacity: 0, y: 20 }}
 whileInView={{ opacity: 1, y: 0 }}
 viewport={{ once: true }}
 transition={{ duration: 0.6, delay: 0.15 }}
 className="md:col-span-7 lg:col-span-8"
 >
 <p className="tag-kicker">Meet the founders</p>
 <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.15] tracking-normal mt-4">
 Devon &amp; Becki <span className="italic text-amber">DeVries.</span>
 </h2>

 <p className="mt-8 text-lg text-white/70 leading-relaxed max-w-2xl">
 Decades on both the creative and executive sides of the music
 industry, with more than{" "}
 <span className="text-amber font-semibold">15,000 sync placements</span>{" "}
 between them. They've shaped the modern landscape of independent
 sync success.
 </p>

 <div className="mt-10 grid sm:grid-cols-2 gap-8">
 <div>
 <p className="font-display text-xl font-semibold">Devon</p>
 <p className="mt-3 text-white/65 text-sm leading-relaxed">
 24-year career. Former Global Head of Sync at 300 Entertainment
 / Warner Brothers via The Bus Music. VP of Creative at Big
 Yellow Dog. Built sync strategy for Megan Thee Stallion,
 Meghan Trainor, Maren Morris, AWOLNATION, Mary J. Blige,
 Shaggy, Gunna, Fetty Wap, Migos and more. Guest lecturer at
 Notre Dame, Belmont, MTSU, TSU, Oakwood and The Wall Street
 Journal.
 </p>
 </div>
 <div>
 <p className="font-display text-xl font-semibold">Becki</p>
 <p className="mt-3 text-white/65 text-sm leading-relaxed">
 Artist, songwriter and music business executive.{" "}
 <span className="text-amber">300+ placements</span> of her own.
 Emmy-nominated vocal credits (Today Show Theme). Vocals for
 Hilary Duff, Delta Goodrem, Amy Grant, Jessica Simpson. Artist
 Developer (A&amp;R) for 300 Entertainment. Mentored creators
 with 5,000+ placements collectively.
 </p>
 </div>
 </div>

 <div
 data-testid="founders-joint-statement"
 className="mt-10 pt-8 border-t border-ink-600"
 >
 <p className="font-display text-xl md:text-2xl leading-snug text-white max-w-4xl">
 Together, they've personally guided{" "}
 <span className="text-amber italic">
 hundreds of independent artists
 </span>{" "}
 from undiscovered to placement-earning, turning real artistry
 into a working career.
 </p>
 </div>
 </motion.div>
 </div>
 </section>
 );
}
